@if (isMapLoaded) {
  <div [formGroup]="formGroup">
    <div class="card">
      <div class="card-body d-flex flex-column">
        <div class="d-flex flex-column">
          <p class="h4 m-0">Endereço do Evento</p>
          <p class="p text-secondary">
            Informe o local exato. No Brasil, pesquise pelo CEP; em outros países, use o código postal e o endereço para
            localizar no mapa.
          </p>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <app-address-form [formGroup]="formGroup" [showAddressName]="true" />
          </div>
          <div class="col-lg-6 col-12">
            <label for="map" class="form-label">Localização do Evento</label>
            <div class="map-container">
              <google-map height="100%" width="100%" [center]="center" [zoom]="15">
                <map-marker [position]="center"></map-marker>
              </google-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else {
  <div>
    <p>Carregando mapa...</p>
  </div>
}
